module.exports = __webpack_public_path__ + "img/weixin.62348283.png";